import React from 'react';
import { DoorOpen } from 'lucide-react';
import GFDIntakeWorkspace from './GFDIntakeWorkspace';

const GFDIntakeDemoPage: React.FC = () => {
  return (
    <div className="App min-h-screen bg-gray-50">
      <header className="bg-super-dark-purple text-white">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center gap-3">
          <DoorOpen className="w-6 h-6 text-electric-blue" />
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-electric-blue">Jarvis · GFD Intake</p>
            <p className="text-sm font-semibold">Champion packet demo (no login)</p>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        <GFDIntakeWorkspace demo />
      </main>
    </div>
  );
};

export default GFDIntakeDemoPage;
